import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { bindActionCreators } from "redux";
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as stdActions from "../../redux/actions/stdAction";
import PropTypes from "prop-types";
import CCMComponent from "../../components/CCM";
import * as ccmActions from "../../redux/actions/ccmAction";
import * as notificationActions from "../../redux/actions/notificationAction";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const CCMPage = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const ccmReducer = useSelector((state) => state.ccmReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  const dispatch = useDispatch();
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const notificationAction = bindActionCreators(notificationActions, dispatch);
  const ccmAction = bindActionCreators(ccmActions, dispatch);
  const userAuthAction = bindActionCreators(userAuthActions, dispatch);
  const notificationReducer = useSelector((state) => state.notification);
  const stdReducer = useSelector((state) => state.stdReducer);

  let stdAction = bindActionCreators(stdActions, dispatch);

  let urllocation = useLocation();
  // Call required apis for dropdown after first render
  useEffect(() => {
    stdAction.prepareStdConfigData(profileReducer.managersDetails.companyId);
  }, []);


  //get All Pending Application
  const getAllPendingApplications = (managerId) => {
    notificationAction.getAllPendingApplications(managerId);
  }

  const setOnSubmit = (isOnSubmit) => {
    notificationAction.setOnSubmit(isOnSubmit);
  }

  //set maxcount in form  
  const setMaximumFormStep = (maxCount) => {
    ccmAction.setMaximumFormStep(maxCount);
  };

  //set minmum Count in Form
  const setMinimumFormStep = (minCount) => {
    ccmAction.setMinimumFormStep(minCount);
  };

  //set Current Form Step
  const setCurrentFormStep = (stepCount) => {
    ccmAction.setCurrentFormStep(stepCount);
  };

  //change language
  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  //for side menu open and close
  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  //for open modal
  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  //for closing modal
  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const resetIsAdded = (isAdded) => {
    ccmAction.resetIsAdded(isAdded);
  };

  //save accomodation
  const addAccomodationStatement = (accomodationData) => {
    ccmAction.addCCMStatement(accomodationData, profileReducer.managersDetails.managerId);
  };

  //resetting accomodation modal
  const resetAccomodationApplicationUrl = () => {
    ccmAction.resetAccomodationApplicationUrl();
  };

  //reset acmd reducer
  const resetACCMDReducer = () => {
    ccmAction.resetState();
  }

  //get jon by location id
  const getJob = (locationID) => {
    commonAction.getJob(locationID);
  };

  //set job details
  const setJob = (jobDetails) => {
    commonAction.setJob(jobDetails);
  };

  //add new job title
  const addNewJobTitle = (jobDetail, locationID) => {
    commonAction.addNewJobTitle(jobDetail, locationID);
  };

  //add new modal
  const addNewManager = (managerDetails) => {
    commonAction.addNewManager(managerDetails);
  };

  const resetSuccessMessage = (message) => {
    commonAction.setSuccessMessage(message);
  }

  const resetsuccessMessageForBackupUserAssigned = () => userAuthAction.resetsuccessMessageForBackupUserAssigned();



  //upload acmd file
  const uploadFiles = (file, allFiles, props) => {
    ccmAction.uploadFiles(file, allFiles, props);
  };

  //remove acmd file
  const removeFiles = (filePath, isDocs, index, allAttachments) => {
    ccmAction.removeFiles(filePath, isDocs, index, allAttachments);
  };

  //set attachment
  const setAttachment = (attachment) => {
    ccmAction.setAttachment(attachment);
  };

  const resetCCMEmployeeStatement = () => ccmAction.resetCCMEmployeeStatement();

  //get all country province
  const getStates = (contryId) => {
    stdAction.getState(contryId);
  }

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <ShowForPermission module={PERMISSON_MODULES.CCM_FORM} permission={PERMISSION_TYPE.VIEW}>
          <CCMComponent
            notificationReducer={notificationReducer}
            urlLocation={urllocation}
            clientinfo={stdReducer.clientInfo}
            stepCount={ccmReducer.step}
            maxStep={ccmReducer.maxSteps}
            minStep={ccmReducer.minSteps}
            setMaxStep={setMaximumFormStep}
            setMinStep={setMinimumFormStep}
            setCurrentFormStep={setCurrentFormStep}
            managersDetails={profileReducer.managersDetails}
            context={context}
            addAccomodationStatement={addAccomodationStatement}
            i18nReducerLang={i18nReducer.lang}
            isAdded={ccmReducer.isAdded}
            accomodationFormPdfLink={ccmReducer.accomodationFormPdfLink}
            resetIsAdded={resetIsAdded}
            resetAccomodationApplicationUrl={resetAccomodationApplicationUrl}
            allPendingApplications={notificationReducer.allPendingApplications}
            resetACCMDReducer={resetACCMDReducer}
            openSetModalAction={openSetModal}
            getAllPendingApplications={getAllPendingApplications}
            closeRemoveModal={closeRemoveModal}
            contiuedPendingApplicationObj={ccmReducer.ccmEmployeeStatement}
            resetContiuedPendingApplicationObj={resetCCMEmployeeStatement}
            state={stdReducer.state}
            country={stdReducer.country}
            region={stdReducer.region}
            location={stdReducer.location}
            planLink={stdReducer.planLink}
            supervisorList={stdReducer.supervisorList}
            job={commonReducer.job}
            getJob={getJob}
            setJob={setJob}
            addNewJobTitle={addNewJobTitle}
            addNewManager={addNewManager}
            attachment={ccmReducer.attachment}
            removeFiles={removeFiles}
            uploadFiles={uploadFiles}
            setAttachment={setAttachment}
            profileReducer={profileReducer}
            resetSuccessMessage={resetSuccessMessage}
            commonReducer={commonReducer}
            resetsuccessMessageForBackupUserAssigned={resetsuccessMessageForBackupUserAssigned}
            getStates={getStates}
          />
        </ShowForPermission>
      </div>
    </>
  );
};

CCMPage.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CCMPage;
